import React from "react";
import { useTranslation } from "react-i18next";
import { Input, Typography, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

const { Title } = Typography;
const { TextArea } = Input;

// CORRECCIÓN: Nombre en PascalCase
export function Step2Clinical({ data, onChange }) {
  const { t } = useTranslation("rooms");

  return (
    <div className="wizard-step">
      <div className="form-section">
        <div className="label-with-info">
          <Title level={5}>{t("asistenteTerapia.paso2.objetivos")}</Title>
          <Tooltip title={t("asistenteTerapia.paso2.objetivosAyuda")}>
            <InfoCircleOutlined style={{ color: "#9CA3AF" }} />
          </Tooltip>
        </div>
        {/*
          El salto de linea del ejemplo iba escrito como entidad HTML (&#10;).
          En el fichero de traduccion va como \n, que es exactamente el mismo
          caracter.
        */}
        <TextArea
          rows={4}
          placeholder={t("asistenteTerapia.paso2.objetivosPlaceholder")}
          value={data.objectives}
          onChange={(e) => onChange("objectives", e.target.value)}
        />
      </div>

      <div className="form-section">
        <div className="label-with-info">
          <Title level={5}>{t("asistenteTerapia.paso2.guion")}</Title>
          <Tooltip title={t("asistenteTerapia.paso2.guionAyuda")}>
            <InfoCircleOutlined style={{ color: "#9CA3AF" }} />
          </Tooltip>
        </div>
        <TextArea
          rows={6}
          placeholder={t("asistenteTerapia.paso2.guionPlaceholder")}
          value={data.script}
          onChange={(e) => onChange("script", e.target.value)}
        />
      </div>
    </div>
  );
}
